<template>
  <el-drawer v-model="visible" :title="titel"  destroy-on-close>
    <el-form ref="roleFormDataRef" label-position="right" label-width="110px" :model="roleFormData" :rules="rules">
      <el-form-item label="角色名称:" prop="name">
        <el-input v-model="roleFormData.name"></el-input>
      </el-form-item>
      <el-form-item label="启用：">
        <el-switch active-text="是" inactive-text="否" :active-value="1" :inactive-value="0" v-model="roleFormData.isEffective"
          inline-prompt ></el-switch>
      </el-form-item>
    </el-form>
    <template #footer>
      <div style="flex: auto">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="saveRole" v-loading="loading">提交</el-button>
      </div>
    </template>
  </el-drawer>
</template>

<script>
import { defineComponent } from 'vue'
import { save} from '@/api/sys/role';
export default defineComponent({
  emits: ['get-data'],
  props: {
    data: Object
  },
  data() {
    return {
      loading: false,
      titel:'角色添加',
      visible: false,
      roleFormData: {
        id: null,
        name:'',
        isEffective:1,
      },
      rules: {
        name: [
          { required: true, message: "请输入角色名称", trigger: "change" },
          { min: 2, max: 20, message: "长度在 2 到 20 个字符", trigger: "change" }
        ],
      },
      
      
    }
  },
  methods: {
    show(row) {
      if(row){
        this.roleFormData=row;
      }else{
        this.roleFormData={
          id: null,
          name:'',
          isEffective:1,
        };
      }
      this.titel=this.roleFormData?'角色添加':'角色编辑';
      this.visible = true;
      
    },
    //保存角色信息
    saveRole() {
      this.$confirm('确定保存角色 <'+this.roleFormData.name+'> ？', '提示').then(_ => {
        save(this.roleFormData).then(({data}) => {
          if (data.status) {
            this.$message.success(data.msg);
            this.$emit('get-data');
            this.visible = false;
          } else {
            this.$message.warning(data.msg);
          }
        }).catch(_ => {})
      }).catch(_ => {})
    }
  }
})
</script>